export class CountryRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }

    public getCountryList(page: number, limit: number, filter?: string, sort?: string): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.ICountryContent>>> {
        return this.$rest.http<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.ICountryContent>>("countryRestService", "getCountryList", {
            page: page,
            limit: limit
        });
    }

    public getZoneByCountryId(countryId: number): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.IZoneContent>>>> {
        return this.$rest.http<Array<qpmn.common.rest.IPaging<qpmn.user.model.domain.area.IZoneContent>>>("countryRestService", "getZoneByCountryId", {
            countryId: countryId
        });
    }
}